import React, { Component } from "react";
import { CircularProgress } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link, withRouter } from "react-router-dom";
import { MotionLoginEmailPassword } from "../../../redux/actions/AuthActions";

import Validator from "./components/Validator";
import BackgrounLogin from "./assets/background.jpg";

import "./SignIn.scss";

const styles = (theme) => ({
  wrapper: {
    position: "relative",
  },

  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
});

class SignIn extends Component {
  state = {
    email: "",
    password: "",
    agreement: "",
    auth: localStorage.getItem("auth_user"),
  };
  handleChange = (event) => {
    event.persist();
    this.setState({ [event.target.name]: event.target.value });
  };
  handleFormSubmit = (event) => {
    let email = this.state.email;
    let password = this.state.password;
    console.log("se enviara esto:");
    console.log({ email, password });
    if (this.state.email && this.state.password) {
      this.props.MotionLoginEmailPassword({ email, password });
      this.setState({
        tryCreate: true,
      });
    } else {
      this.setState({
        tryCreate: true,
        created: false,
      });
    }
  };
  componentDidMount() {
    if (this.state.auth != null) {
      console.log("Se encontro auth in state: ");
      console.log(this.state.auth);
      window.location.replace("/");
    } else {
      console.log("no se encontro auth en local storage");
    }
  }
  render() {
    let { email, password } = this.state;
    let { classes } = this.props;
    return (
      <div className="bg-gradient">
        <div
          className="bg-photo"
          style={{ backgroundImage: `url(${BackgrounLogin})` }}
        ></div>

        <div className="bg-gradient-2"></div>

        <div className="logo-motion">
          <a href="http://monitoringinnovation.com">
            <img src="/assets/images/motion-logo.svg" alt="motion-logo" />
          </a>
        </div>
        <div>
          <ValidatorForm
            className="form"
            ref="form"
            onSubmit={this.handleFormSubmit}
          >
            <div>Usuario*</div>
            <Validator
              parameter={email}
              tryCreate={this.state.tryCreate}
              placeholder={"Nombre de usuario"}
              error={"Email requerido"}
              handleChange={this.handleChange}
              name={"email"}
            />
            <div>Clave de acceso*</div>
            <Validator
              parameter={password}
              tryCreate={this.state.tryCreate}
              placeholder={"Contraseña"}
              error={"Password requerido"}
              handleChange={this.handleChange}
              name={"password"}
              type="password"
            />
            <div className="form-selections">
              <a className="forgotten-password" href="/olvidePassword">
                He olvidado mi contraseña
              </a>
              <br />
              <button type="submit" className="button-form">
                Iniciar sesión
              </button>
              {this.props.login.loading && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}
              <br />
              <Link className="register-option">Registrarme</Link>
            </div>
          </ValidatorForm>
        </div>

        <footer className="footer">
          <p>
            &copy; 2021 Copyright
            <a href="http://monitoringinnovation.com">A.B Comercial LTDA</a>
          </p>
        </footer>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  MotionLoginEmailPassword: PropTypes.func.isRequired,
  login: state.login,
});
export default withStyles(styles, { withTheme: false })(
  withRouter(connect(mapStateToProps, { MotionLoginEmailPassword })(SignIn))
);
